export type TAPI_NAME = {
    [name: string]: string;
};

export const API_NAMES: TAPI_NAME = {
    GET_ORDER_POS_SYNC: "GET_ORDER_POS_SYNC",
    GET_ORDER_DETAILS_REQUEST: "GET_ORDER_DETAILS_REQUEST",
    GET_RETAIL_LOCATIONS: "GET_RETAIL_LOCATIONS",
    POST_ORDER_ITEMS_RELATIONS_SUMMARY: "POST_ORDER_ITEMS_RELATIONS_SUMMARY",
};

export const HTTP_STATUS = {
    OK: 200,
    CREATED: 201,
    ACCEPTED: 202,
    NO_CONTENT: 204,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    INTERNAL_SERVER_ERROR: 500,
};
